<template>
    <div class="re-container">
        <el-scrollbar shadow="never" class="re-stat-scrollbar">
            <div class="top-container">
                <div class="top-item1">
                    <el-affix :offset="5">
                        <div class="download-btn-l" @click="handleDownload">下载PDF报告</div>
                    </el-affix>
                </div>
                <div class="top-item2">课堂教学实施能力分析报告</div>
                <div class="top-item1">
                    <el-affix :offset="5">
                        <el-popover placement="bottom" trigger="hover" :width="100"
                                    :show-arrow="true"
                                    :popper-style="{padding: '5',background:'#f0f0f0',border: 'none',minWidth:'220px'}">
                            <div :class="this.parentId==='1'?'menu-parent active':'menu-parent'" @click="jumpToItem('1','item10')">
                                一、课堂教学总体概览
                            </div>
                            <ul class="subsections">
                                <li :class="this.itemId==='item11'?'active':''" @click="jumpToItem('1','item11')">&nbsp;&nbsp;1. 课堂概览</li>
                                <li :class="this.itemId==='item12'?'active':''" @click="jumpToItem('1','item12')">&nbsp;&nbsp;2. 本课亮点</li>
                                <li :class="this.itemId==='item13'?'active':''" @click="jumpToItem('1','item13')">&nbsp;&nbsp;3. 能力增强点</li>
                                <li :class="this.itemId==='item14'?'active':''" @click="jumpToItem('1','item14')">&nbsp;&nbsp;4. 改进建议</li>
                            </ul>
                            <div :class="this.parentId==='2'?'menu-parent active':'menu-parent'" @click="jumpToItem('2','item20')">
                                二、课堂评估量表数据分析
                            </div>
                            <ul data-v-fc54b2d4 class= subsections >
                                <li :class="this.itemId==='item21'?'active':''" @click="jumpToItem('2','item21')">&nbsp;&nbsp;1. 课标与教材解读</li>
                                <li :class="this.itemId==='item22'?'active':''" @click="jumpToItem('2','item22')">&nbsp;&nbsp;2. 教学设计实施</li>
                                <li :class="this.itemId==='item23'?'active':''" @click="jumpToItem('2','item23')">&nbsp;&nbsp;3. 教学反思评价</li>
                                <li :class="this.itemId==='item24'?'active':''" @click="jumpToItem('2','item24')">&nbsp;&nbsp;4. 技术融合教学</li>
                                <li :class="this.itemId==='item25'?'active':''" @click="jumpToItem('2','item25')">&nbsp;&nbsp;5. 教学效果评估</li>
                            </ul>
                            <div :class="this.parentId==='3'?'menu-parent active':'menu-parent'" @click="jumpToItem('3','item30')">
                                三、附录
                            </div>
                            <ul data-v-fc54b2d4 class= subsections >
                                <li :class="this.itemId==='item31'?'active':''" @click="jumpToItem('3','item31')">&nbsp;&nbsp;1. 附录A</li>
                                <li :class="this.itemId==='item32'?'active':''" @click="jumpToItem('3','item32')">&nbsp;&nbsp;2. 附录B</li>
                            </ul>
                            <template #reference>
                                <div class="download-btn-r">报告导航栏</div>
                            </template>
                        </el-popover>
                    </el-affix>
                </div>
            </div>

            <div class="report-container">
                <div class="item-gd"></div>
                <div class="report-info-center">
                    <div class="report-info-item">
                        <div style="width: 100%;"><span class="r-font">报告编号:</span>{{taskInfo.relationId}}</div>
                    </div>
                <div class="report-info-item">
                    <p><span class="r-font">课程名称：</span>{{taskInfo.taskName}}</p>
                </div>
                <div class="report-info-item">
                    <p><span class="r-font">综合得分：</span>{{infoData.score}}</p>
                </div>
                <div class="report-info-item">
                    <p><span class="r-font">综合指数：</span>{{infoData.compscore}}</p>
                </div>
                <div class="report-info-item">
                    <p><span class="r-font">评级：</span>{{infoData.rate}}</p>
                </div>
                <div class="report-info-item">
                    <p><span class="r-font">学段：</span>{{taskInfo.periodName}}</p>
                </div>
                <div class="report-info-item">
                    <p><span class="r-font">学科：</span>{{taskInfo.subjectName}}</p>
                </div>
                <div class="report-info-item">
                    <p><span class="r-font">教师姓名：</span>{{taskInfo.trueName}}</p>
                </div>
                <div class="report-info-item">
                    <p><span class="r-font">分析日期：</span>{{timestampToTime(taskInfo.createTime)}}</p>
                </div>
                </div>
                <div class="item-gd"></div>
                <div class="item-gd"></div>
                <div class="top-h2 f-c">导读</div>
                <div class="item-gd"></div>
                <p class="p-indent">
                    尊敬的{{taskInfo.trueName}}老师，本报告基于人工智能技术，对您的教学实践进行了全面分析，并与优质课基准进行对比，
                    旨在帮助您优化教学策略、提升课堂效果。 报告包括三个部分：课堂教学总体概览、
                    课堂评估量表数据分析和附录。如有任何疑问，欢迎随时联系我们。 感谢您对教学质量的不断追求，
                    期待与您共同努力，为学生创造更加精彩的未来。
                </p>
                <div class="top-h2 f-l" id="item10">一、课堂教学总体概览</div>
                <div class="top-h3 f-l" id="item11">1.1 课堂概览</div>
                <div class="top-h3 f-l">1.1.1 课堂概述</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" width="20%">项目</th>
                            <th>分析结果描述</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td align="center" class="r-font border-l-none">教学目标</td>
                            <td style="padding: 5px;">{{infoData.teachobjectives}}</td>
                        </tr>
                        <tr>
                            <td align="center" class="r-font border-l-none">重点难点</td>
                            <td style="padding: 5px;">
                                <span class="r-font">重点：</span>{{keyDifficult.重点}} <br/>
                                <span class="r-font">难点：</span>{{keyDifficult.难点}}
                            </td>
                        </tr>
                        <tr>
                            <td align="center" class="r-font border-l-none">课堂类型</td>
                            <td style="padding: 5px;">本课为“{{lessonType}}”课堂（根据S-T模型判断）。<a class="blue-link" @click="handleLessonTypeDataView">[点击查看详细数据]</a></td>
                        </tr>
                        <tr>
                            <td align="center" class="r-font border-l-none">总体概述</td>
                            <td style="padding: 5px;">{{infoData.alloverview}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="top-h3 f-l">1.1.2 一级指标综合指数和得分统计</div>
                <div class="charts-container">
                    <radar-chart :id="'radar-chart-1'" :data-list="this.oneData" />
                </div>

                <p class="p-indent">
                    本课堂的课堂评分为<strong><u>&nbsp;{{dataOverview.总分}}&nbsp;</u></strong> 分，
                    其中 <strong style="color: rgb(0, 128, 0);"><u>&nbsp;"{{highData.名字}}"&nbsp;</u></strong>指标表现突出，
                    得分较高（ <strong style="color: rgb(0, 128, 0);"><u>&nbsp;"{{highData.分数}}"&nbsp;</u></strong>  分）；
                    {{highData.说明}}
                    另外，<strong style="color: red"><u>&nbsp;"{{lowData.名字}}"&nbsp;</u></strong>指标的
                    得分较低（ <strong style="color: red;"><u>&nbsp;"{{lowData.分数}}"&nbsp;</u></strong>  分）；
                    {{lowData.建议}}
                </p>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" width="10%">序号</th>
                            <th>一级指标</th>
                            <th>当前值(指数/得分)</th>
                            <th>基准值(指数/得分)</th>
                            <th>当前评分等级</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="(item,index) in oneData" :key="item">
                            <td align="center" class="border-l-none">{{index+1}}</td>
                            <td align="center">{{item.name}}</td>
                            <td align="center">{{item.index_value}}%&nbsp;&nbsp;{{item.score_value}}分</td>
                            <td align="center">{{item.ck_index_value}}%&nbsp;&nbsp;{{item.ck_value_score}}分</td>
                            <td align="center">{{item.grade}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="top-h3 f-l" id="item12">1.2 本课亮点</div>
                <div class="p-indent" style="color: rgb(0, 128, 0);font-weight: bold;">{{lightSpot.name}}</div>
                <div class="p-indent">{{lightSpot.描述}}<a class="blue-link" @click="handleDataAnalysis(lightSpot.id)">[点击查看详细数据]</a></div>
                <div class="top-h3 f-l" id="item13">1.3 能力增强点</div>
                <div class="p-indent" style="color: red;font-weight: bold;">{{insufficient.name}}</div>
                <div class="p-indent">{{insufficient.描述}}<a class="blue-link" @click="handleDataAnalysis(insufficient.id)">[点击查看详细数据]</a></div>
                <div class="top-h3 f-l" id="item14">1.4 改进建议</div>
                <div class="p-indent">{{infoData.advise}}</div>


                <div class="top-h2 f-l" id="item20">二、课堂评估量表数据分析</div>
                <div class="top-h3 f-l" id="item21">2.1 一级指标：课标与教材解读</div>
                <div class="top-h3 f-l">2.1.1 二级指标综合指数可视化展示</div>
                <div class="charts-container">
                    <double-bar-chart :id="'double-bar-chart-2-1-1'" :data-list="this.chartData1" />
                </div>
                <div class="top-h3 f-l">2.1.2 各指标数据分析表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" width="100">要素</th>
                            <th align="center" width="80">指标</th>
                            <th align="center" width="80">评估指数</th>
                            <th align="center" width="80">得分</th>
                            <th align="center" width="160">亮点或问题</th>
                            <th align="center">建议</th>
                        </tr>
                        </thead>
                        <tbody v-for="(item,index) in chartData1" :key="index">
                        <tr>
                            <td class="border-l-none" align="center" :rowspan="(item.third_target.length+1)" >{{item.name}}</td>
                        </tr>
                        <tr v-for="(item2,index2) in item.third_target" :key="index2">
                            <td align="center" >{{item2.name}}</td>
                            <td align="center" ><a class="xiahuaxian">{{item2.index_value}}%</a></td>
                            <td align="center" >
                                <div class="rating">评级:{{item2.grade}}</div>
                                <a class="xiahuaxian">{{item2.score_value}}</a>
                            </td>
                            <td align="center" >
                                <div class="legend">
                                    <div class="legend-color" style="background-color: rgb(230, 162, 60);"></div>
                                    <span class="legend-text">待提高</span>
                                    <div class="legend-color" style="background-color: rgb(64, 158, 255);"></div>
                                    <span class="legend-text">参考值</span>
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#E6A23C" :stroke-width="16" :percentage="item2.index_value" />
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#409EFF" :stroke-width="16" :percentage="item2.ck_index_value" />
                                </div>
                                <div class="rating">
                                    <a class="blue-link" @click="handleDataAnalysis(item2.id)">点击查看数据解析</a>
                                </div>
                            </td>
                            <td >{{item2.advice}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>


                <div class="top-h3 f-l" id="item22">2.2 一级指标：教学设计实施</div>
                <div class="top-h3 f-l">2.2.1 二级指标综合指数可视化展示</div>
                <div class="charts-container">
                    <double-bar-chart :id="'double-bar-chart-2-2-1'" :data-list="this.chartData2" />
                </div>
                <div class="top-h3 f-l">2.2.2 各指标数据分析表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" width="100">要素</th>
                            <th align="center" width="80">指标</th>
                            <th align="center" width="80">评估指数</th>
                            <th align="center" width="80">得分</th>
                            <th align="center" width="160">亮点或问题</th>
                            <th align="center">建议</th>
                        </tr>
                        </thead>
                        <tbody v-for="(item,index) in chartData2" :key="index">
                        <tr>
                            <td class="border-l-none" align="center" :rowspan="(item.third_target.length+1)" >{{item.name}}</td>
                        </tr>
                        <tr v-for="(item2,index2) in item.third_target" :key="index2">
                            <td align="center" >{{item2.name}}</td>
                            <td align="center" ><a class="xiahuaxian">{{item2.index_value}}%</a></td>
                            <td align="center" >
                                <div class="rating">评级:{{item2.grade}}</div>
                                <a class="xiahuaxian">{{item2.score_value}}</a>
                            </td>
                            <td align="center" >
                                <div class="legend">
                                    <div class="legend-color" style="background-color: rgb(230, 162, 60);"></div>
                                    <span class="legend-text">待提高</span>
                                    <div class="legend-color" style="background-color: rgb(64, 158, 255);"></div>
                                    <span class="legend-text">参考值</span>
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#E6A23C" :stroke-width="16" :percentage="item2.index_value" />
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#409EFF" :stroke-width="16" :percentage="item2.ck_index_value" />
                                </div>
                                <div class="rating">
                                    <a class="blue-link" @click="handleDataAnalysis(item2.id)">点击查看数据解析</a>
                                </div>
                            </td>
                            <td >{{item2.advice}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>


                <div class="top-h3 f-l" id="item23">2.3 一级指标：教学反思评价</div>
                <div class="top-h3 f-l">2.3.1 二级指标综合指数可视化展示</div>
                <div class="charts-container">
                    <double-bar-chart :id="'double-bar-chart-2-3-1'" :data-list="this.chartData3" />
                </div>
                <div class="top-h3 f-l">2.3.2 各指标数据分析表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" width="100">要素</th>
                            <th align="center" width="80">指标</th>
                            <th align="center" width="80">评估指数</th>
                            <th align="center" width="80">得分</th>
                            <th align="center" width="160">亮点或问题</th>
                            <th align="center">建议</th>
                        </tr>
                        </thead>
                        <tbody v-for="(item,index) in chartData3" :key="index">
                        <tr>
                            <td class="border-l-none" align="center" :rowspan="(item.third_target.length+1)" >{{item.name}}</td>
                        </tr>
                        <tr v-for="(item2,index2) in item.third_target" :key="index2">
                            <td align="center" >{{item2.name}}</td>
                            <td align="center" ><a class="xiahuaxian">{{item2.index_value}}%</a></td>
                            <td align="center" >
                                <div class="rating">评级:{{item2.grade}}</div>
                                <a class="xiahuaxian">{{item2.score_value}}</a>
                            </td>
                            <td align="center" >
                                <div class="legend">
                                    <div class="legend-color" style="background-color: rgb(230, 162, 60);"></div>
                                    <span class="legend-text">待提高</span>
                                    <div class="legend-color" style="background-color: rgb(64, 158, 255);"></div>
                                    <span class="legend-text">参考值</span>
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#E6A23C" :stroke-width="16" :percentage="item2.index_value" />
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#409EFF" :stroke-width="16" :percentage="item2.ck_index_value" />
                                </div>
                                <div class="rating">
                                    <a class="blue-link" @click="handleDataAnalysis(item2.id)">点击查看数据解析</a>
                                </div>
                            </td>
                            <td >{{item2.advice}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>


                <div class="top-h3 f-l" id="item24">2.4 一级指标：技术融合教学</div>
                <div class="top-h3 f-l">2.4.1 二级指标综合指数可视化展示</div>
                <div class="charts-container">
                    <double-bar-chart :id="'double-bar-chart-2-4-1'" :data-list="this.chartData4" />
                </div>
                <div class="top-h3 f-l">2.4.2 各指标数据分析表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" width="100">要素</th>
                            <th align="center" width="80">指标</th>
                            <th align="center" width="80">评估指数</th>
                            <th align="center" width="80">得分</th>
                            <th align="center" width="160">亮点或问题</th>
                            <th align="center">建议</th>
                        </tr>
                        </thead>
                        <tbody v-for="(item,index) in chartData4" :key="index">
                        <tr>
                            <td class="border-l-none" align="center" :rowspan="(item.third_target.length+1)" >{{item.name}}</td>
                        </tr>
                        <tr v-for="(item2,index2) in item.third_target" :key="index2">
                            <td align="center" >{{item2.name}}</td>
                            <td align="center" ><a class="xiahuaxian">{{item2.index_value}}%</a></td>
                            <td align="center" >
                                <div class="rating">评级:{{item2.grade}}</div>
                                <a class="xiahuaxian">{{item2.score_value}}</a>
                            </td>
                            <td align="center" >
                                <div class="legend">
                                    <div class="legend-color" style="background-color: rgb(230, 162, 60);"></div>
                                    <span class="legend-text">待提高</span>
                                    <div class="legend-color" style="background-color: rgb(64, 158, 255);"></div>
                                    <span class="legend-text">参考值</span>
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#E6A23C" :stroke-width="16" :percentage="item2.index_value" />
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#409EFF" :stroke-width="16" :percentage="item2.ck_index_value" />
                                </div>
                                <div class="rating">
                                    <a class="blue-link" @click="handleDataAnalysis(item2.id)">点击查看数据解析</a>
                                </div>
                            </td>
                            <td >{{item2.advice}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>


                <div class="top-h3 f-l" id="item25">2.5 一级指标：教学效果评估</div>
                <div class="top-h3 f-l">2.5.1 二级指标综合指数可视化展示</div>
                <div class="charts-container">
                    <double-bar-chart :id="'double-bar-chart-2-5-1'" :data-list="this.chartData5" />
                </div>
                <div class="top-h3 f-l">2.5.2 各指标数据分析表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" width="100">要素</th>
                            <th align="center" width="80">指标</th>
                            <th align="center" width="80">评估指数</th>
                            <th align="center" width="80">得分</th>
                            <th align="center" width="160">亮点或问题</th>
                            <th align="center">建议</th>
                        </tr>
                        </thead>
                        <tbody v-for="(item,index) in chartData5" :key="index">
                        <tr>
                            <td class="border-l-none" align="center" :rowspan="(item.third_target.length+1)" >{{item.name}}</td>
                        </tr>
                        <tr v-for="(item2,index2) in item.third_target" :key="index2">
                            <td align="center" >{{item2.name}}</td>
                            <td align="center" ><a class="xiahuaxian">{{item2.index_value}}%</a></td>
                            <td align="center" >
                                <div class="rating">评级:{{item2.grade}}</div>
                                <a class="xiahuaxian">{{item2.score_value}}</a>
                            </td>
                            <td align="center" >
                                <div class="legend">
                                    <div class="legend-color" style="background-color: rgb(230, 162, 60);"></div>
                                    <span class="legend-text">待提高</span>
                                    <div class="legend-color" style="background-color: rgb(64, 158, 255);"></div>
                                    <span class="legend-text">参考值</span>
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#E6A23C" :stroke-width="16" :percentage="item2.index_value" />
                                </div>
                                <div class="progress-container">
                                    <el-progress :text-inside="true" color="#409EFF" :stroke-width="16" :percentage="item2.ck_index_value" />
                                </div>
                                <div class="rating">
                                    <a class="blue-link" @click="handleDataAnalysis(item2.id)">点击查看数据解析</a>
                                </div>
                            </td>
                            <td >{{item2.advice}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="top-h2 f-l" id="item30">三、附录</div>
                <div class="top-h3 f-l" id="item31">附录A</div>
                <div class="top-h3 f-l">1 定义</div>
                <div class="top-h3 f-l">1.1 综合指数定义</div>
                <div class="p-indent">
                    定义：综合指数值直接反映了被评者在本评估维度上的详细表现情况。 通过系统分析多个维度的具体指标（如教学时长、教学次数、教学效果、学生参与度等），并按其重要性对每个指标进行加权处理，生成一个统一的综合指数。 这种方法保证了评估的科学性和客观性。每个指标的综合指数都经过标准化（归一化）处理，确保不同指标间的可比性。 生成综合指数后，可以与优质课程的综合指数平均值进行对比，根据相应的离散化程度和区间段输出相应的评估分数或等级（ABCDE）。
                </div>
                <div class="top-h3 f-l">1.2 评分等级定义</div>
                <div class="top-h4 f-l">1.2.1 A等级（卓越）</div>
                <div class="p-indent">
                    A（85-100分）: 您的教学非常优秀，课程设计严谨，教学方法多样，课堂管理出色，学生参与度很高。您为学生的学习体验做出了重要贡献！
                </div>
                <div class="top-h4 f-l">1.2.2 B等级（优秀）</div>
                <div class="p-indent">
                    B（70-84分）: 您的教学表现出色，课程内容详实，教学方法灵活，课堂管理有效。学生们受益匪浅，期待您继续保持这种优秀表现！
                </div>
                <div class="top-h4 f-l">1.2.3 C等级（良好）</div>
                <div class="p-indent">
                    C（55-69分）: 您的教学达到了基本要求，课程内容完整，教学方法适当。学生们能够从您的课程中受益，期待您在未来的教学中进一步完善！
                </div>
                <div class="top-h4 f-l">1.2.4 D等级（需要改进）</div>
                <div class="p-indent">
                    D（40-54分）: 您的教学需要一些调整，课程内容和教学方法可以进一步优化。学生们的反馈显示出您的潜力所在，期待您的改进和提升！
                </div>
                <div class="top-h4 f-l">1.2.5 E等级（急需改进）</div>
                <div class="p-indent">
                    E（0-39分）: 您的教学有较大改进空间，课程内容和教学方法需要重新考虑。学生们的反馈为您提供了宝贵的建议，期待您的积极改变！
                </div>

                <div class="top-h3 f-l">1.3 评估指标教学定义</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr >
                            <th align="center" width="120">维度</th>
                            <th align="center" width="180">指标</th>
                            <th align="center" width="180">要素</th>
                            <th align="center">要素教学定义</th>
                        </tr>
                        </thead>
                    </table>
                    <table class="tablecss">
                        <tbody v-for="item in evaList" :key="index1">
                        <tr>
                            <td width="120" class="border-l-none" align="center" :rowspan="(item.second_target.length+1)" >{{item.name}}</td>
                        </tr>
                        <tbody v-for="(item2,index2) in item.second_target" :key="index2">
                        <tr>
                            <td width="180" align="center" :rowspan="(item2.third_target.length+1)" >{{item2.name}}</td>
                        </tr>
                        <tr v-for="(item3,index3) in item2.third_target" :key="index3">
                            <td align="center" width="180" >{{item3.name}}</td>
                            <td align="center" >{{item3.teaching_define}}</td>
                        </tr>
                        </tbody>
                        </tbody>
                    </table>
                </div>

                <div class="top-h3 f-l" id="item32">附录B</div>
                <div class="top-h3 f-l">1. 课堂教学事件分析</div>
                <div class="top-h3 f-l">1.1 可视化图</div>
                <div class="charts-container">
                    <teaching-event-data-echart :id="'teachingEventDataEchart1'"
                                                :title="'加涅9事件时序图'"
                                                :video-url="this.taskInfo.videoUrl"
                                                :data-list="this.teachingEventData"
                                                @view-course-video="videoCourseVideo"/>
                </div>
                <div class="top-h3 f-l">1.2 课堂教学事件统计表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr >
                            <th align="center">序号</th>
                            <th align="center">指标</th>
                            <th >教学定义</th>
                            <th align="center">次数</th>
                            <th align="center">时长（分钟）</th>
                        </tr>
                        </thead>
                        <tbody >
                        <tr v-for="(item,index) in teachingEventData" :key="index">
                            <td align="center" width="50">{{index+1}}</td>
                            <td align="center" width="160">{{item.event_name}}</td>
                            <td>{{item.event_description}}</td>
                            <td align="center" width="120">{{item.event_num}}</td>
                            <td align="center" width="130">{{item.event_duration}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="top-h3 f-l">2. 课堂活动分析</div>
                <div class="top-h3 f-l">2.1 可视化图</div>
                <div class="charts-container">
                    <class-activity-data-echart :id="'classActivityDataEchart1'"
                                                :video-url="this.taskInfo.videoUrl"
                                                :title="'课堂活动时序图'"
                                                :data-list="this.classActivityData"
                                                @view-course-video="videoCourseVideo"/>
                </div>
                <div class="top-h3 f-l">2.2 课堂活动统计表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr >
                            <th align="center">序号</th>
                            <th align="center">指标</th>
                            <th >教学定义</th>
                            <th align="center">次数</th>
                            <th align="center">时长（分钟）</th>
                        </tr>
                        </thead>
                        <tbody >
                        <tr v-for="(item,index) in classActivityData" :key="index">
                            <td align="center" width="50">{{index+1}}</td>
                            <td align="center" width="160">{{item.event_name}}</td>
                            <td>{{item.event_description}}</td>
                            <td align="center" width="120">{{item.event_num}}</td>
                            <td align="center" width="130">{{item.event_duration}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="top-h3 f-l">3. 教学行为分析</div>
                <div class="top-h3 f-l">3.1 可视化图</div>
                <div class="charts-container">
                    <teaching-behavior-data-echart :id="'teachingBehaviorDataEchart1'"
                                                   :video-url="this.taskInfo.videoUrl"
                                                   :title="'教学行为时序图'"
                                                   :data-list="this.teachingBehaviorData"
                                                   @view-course-video="videoCourseVideo"/>
                </div>
                <div class="top-h3 f-l">3.2 教学行为统计表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr >
                            <th align="center">维度</th>
                            <th >教学定义</th>
                            <th align="center">次数</th>
                            <th align="center">时长（分钟）</th>
                        </tr>
                        </thead>
                        <tbody v-for="(item,index) in teachingBehaviorData" >
                        <tr>
                            <td align="left" style="font-weight: bold;padding-left: 5px;height: 40px;" colspan="4">{{index+1}}.{{item.event_name}}</td>
                        </tr>
                        <tr v-for="item1 in item.second_event">
                            <td align="center" width="160">{{item1.event_name}}</td>
                            <td>{{item1.event_description}}</td>
                            <td align="center" width="120">{{item1.event_num}}</td>
                            <td align="center" width="130">{{item1.event_duration}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="top-h3 f-l">4. 师生对话深度评估</div>
                <div class="top-h3 f-l">4.1 可视化图</div>
                <div class="charts-container">
                    <interactive-eva-data-echart :id="'interactiveEvaDataEchart1'"
                                                 :title="'师生对话深度时序图'"
                                                 :video-url="this.taskInfo.videoUrl"
                                                 :data-list="this.interactiveEvaData"
                                                 @view-course-video="videoCourseVideo"/>
                </div>
                <div class="top-h3 f-l">4.2 师生对话深度统计表</div>
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr >
                            <th align="center">序号</th>
                            <th align="center">指标</th>
                            <th >教学定义</th>
                            <th align="center">次数</th>
                            <th align="center">时长（分钟）</th>
                        </tr>
                        </thead>
                        <tbody >
                        <tr v-for="(item,index) in interactiveEvaData" :key="index">
                            <td align="center" width="50">{{index+1}}</td>
                            <td align="center" width="160">{{item.event_name}}</td>
                            <td>{{item.event_description}}</td>
                            <td align="center" width="120">{{item.event_num}}</td>
                            <td align="center" width="130">{{item.event_duration}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>


                <div class="top-h3 f-l">5. S-T模型分析</div>
                <div class="top-h3 f-l">5.1 S-T图</div>
                <div class="charts-container">
                    <st-data-chart :id="'stDataEchart1'"
                                   :data-list="stList"/>
                    <div class="clearfix">
                        <p class="p1">说明：</p>
                        <p class="p2">师生互动曲线描述的是老师和学生的互动情况。</p>
                        <p class="p2">沿横轴方向的线段代表老师行为，沿纵轴方向的线段代表学生行为。</p>
                        <p class="p2">当曲线偏向横轴时，表示老师活动占多数，偏向纵轴时，学生活动占多数。</p>
                        <p class="p2">当某段曲线整体平行于45 度线时，表示在此段时间内老师学生互动充分。</p>
                    </div>
                </div>
                <div class="top-h3 f-l">5.2 Rt-Ch图</div>
                <div class="charts-container">
                    <rt-ch-data-chart :id="'rtChDataEchart1'"
                                      :rt-num="this.rt"
                                      :ch-num="this.ch"/>
                    <div class="clearfix">
                        <p class="p1">说明：</p>
                        <table class="tablecss">
                            <tbody>
                            <tr>
                                <td align="center" style="font-weight: bold; width: 40%;border-bottom: 1px solid #ccc;">Rt（教师行为占有率）</td>
                                <td style="padding: 10px;border-left: 1px solid #ccc;border-bottom: 1px solid #ccc;">{{(rt/100).toFixed(3)}}</td>
                            </tr>
                            <tr>
                                <td align="center" style="font-weight: bold; width: 40%;border-bottom: 1px solid #ccc;">Ch（转换率）</td>
                                <td style="padding: 10px;border-left: 1px solid #ccc;border-bottom: 1px solid #ccc;">{{(ch/100).toFixed(3)}}</td>
                            </tr>
                            <tr>
                                <td align="center" style="font-weight: bold; width: 40%;">课堂类型</td>
                                <td style="padding: 10px;border-left: 1px solid #ccc;">{{lessonType}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <p class="p2">练习型：Rt↓，Ch↓ （Rt ≤ 0.3）</p>
                        <p class="p2">讲授型：Rt↑，Ch↓ （Rt ≥ 0.7）</p>
                        <p class="p2">对话型：Rt居中，Ch↑ （Ch ≥ 0.4）</p>
                        <p class="p2">混合型：0.3 ≤ Rt ≤ 0.7，Ch &lt; 0.4</p>
                        <p class="p2">其物理意义为：Rt↑→教师活动多；Ch↑→师生互动多。</p>
                    </div>
                </div>

                <div class="top-h3 f-l">6. 弗兰德斯教学模型分析</div>
                <div class="top-h3 f-l">6.1 互动矩阵图</div>
                <div class="charts-container">
                    <div class="model-container">
                        <table class="tablecss flds-matrix">
                            <tbody>
                            <tr style="height: 50px;">
                                <td align="center" :rowspan="2" style="width: 6%;">分类</td>
                                <td align="center" :colspan="7">教师语言</td>
                                <td align="center" :colspan="3">学生语言</td>
                                <td align="center" :colspan="2">课堂状态</td>
                                <td align="center" :colspan="2">多媒体技术</td>
                            </tr>
                            <tr style="height: 180px;">
                                <td align="center" style="width: 6.6%;">接纳情感</td>
                                <td align="center" style="width: 6.6%;">鼓励或表扬</td>
                                <td align="center" style="width: 6.6%;">接纳或利用学生的观点</td>
                                <td align="center" style="width: 6.6%;">提问</td>
                                <td align="center" style="width: 6.6%;">讲授</td>
                                <td align="center" style="width: 6.6%;">给予指导或指令</td>
                                <td align="center" style="width: 6.6%;">批评或维护权威性</td>
                                <td align="center" style="width: 6.6%;">学生应答</td>
                                <td align="center" style="width: 6.6%;">学生主动说话</td>
                                <td align="center" style="width: 6.6%;">小组讨论</td>
                                <td align="center" style="width: 6.6%;">无助于教学的混乱</td>
                                <td align="center" style="width: 6.6%;">思考练习笔记</td>
                                <td align="center" style="width: 6.6%;">教师应用技术</td>
                                <td align="center" style="width: 6.6%;">学生应用技术</td>
                            </tr>
                            <tr style="height: 50px;">
                                <td align="center" style="width: 6%;">序号</td>
                                <td align="center" style="width: 6.6%;">1</td>
                                <td align="center" style="width: 6.6%;">2</td>
                                <td align="center" style="width: 6.6%;">3</td>
                                <td align="center" style="width: 6.6%;">4</td>
                                <td align="center" style="width: 6.6%;">5</td>
                                <td align="center" style="width: 6.6%;">6</td>
                                <td align="center" style="width: 6.6%;">7</td>
                                <td align="center" style="width: 6.6%;">8</td>
                                <td align="center" style="width: 6.6%;">9</td>
                                <td align="center" style="width: 6.6%;">10</td>
                                <td align="center" style="width: 6.6%;">11</td>
                                <td align="center" style="width: 6.6%;">12</td>
                                <td align="center" style="width: 6.6%;">13</td>
                                <td align="center" style="width: 6.6%;">14</td>
                            </tr>
                            <tr style="height: 50px;" v-for="(num,index) in mumList" :key="index">
                                <td align="center" style="width: 6%;">{{num}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+1">{{gainTableItem('tableId'+num+1)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+2">{{gainTableItem('tableId'+num+2)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+3">{{gainTableItem('tableId'+num+3)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+4">{{gainTableItem('tableId'+num+4)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+5">{{gainTableItem('tableId'+num+5)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+6">{{gainTableItem('tableId'+num+6)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+7">{{gainTableItem('tableId'+num+7)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+8">{{gainTableItem('tableId'+num+8)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+9">{{gainTableItem('tableId'+num+9)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+10">{{gainTableItem('tableId'+num+10)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+11">{{gainTableItem('tableId'+num+11)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+12">{{gainTableItem('tableId'+num+12)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+13">{{gainTableItem('tableId'+num+13)}}</td>
                                <td align="center" style="width: 6.6%;" :id="'tableId'+num+14">{{gainTableItem('tableId'+num+14)}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="flds-title1">积极整合格</div>
                    <div class="flds-content">
                        矩阵中 1~3 行与 1~3 列相交的「黄色」区域是积极整合格，如在此区域记录是体现教师在授课过程中有采纳、表扬、鼓励学生的发言、行为、动作或者认可学生的观点，若此区域记录较为密集，反映出师生之间情感气氛融洽。
                    </div>
                    <div class="flds-title4">缺陷格</div>
                    <div class="flds-content">
                        矩阵中 7~8 行与 6~7 列相交的「红色」区域是缺陷格，在此区域中记录，说明课堂内出现了教师为维护权威批评学生或指令学生做某些事情等非积极的情况发生。如果在这个区域中记录的次数很少，也反应教师与学生语言交流的融洽，如果在这个区域里记录的次数密集，则反映是教师和学生之间情感交流上的隔阂，是课堂上应注意避免的缺陷。
                    </div>
                    <div class="flds-title5">稳态格</div>
                    <div class="flds-content">
                        矩阵中对角线上（左上到右下）的各个单元格叫做稳态格，编码落在这些格里，表示某种行为出现的时间超过 3 秒钟，表明持续地做某事。
                    </div>
                    <div class="flds-title3">提问引导格</div>
                    <div class="flds-content">
                        矩阵中「绿色」区域为“提问引导”课堂类型。出现在此区域中是说明教师在教学过程中采用了提问、引导等手段来驱动学生回答，代表了训练型提问的程度。
                    </div>
                    <div class="flds-title2">主动延伸格</div>
                    <div class="flds-content">
                        矩阵中「蓝色」区域为“主动延伸”课堂类型。出现在此区域中显示了教师在课堂内通过接受或采纳学生意见诱导学生主动发言的情况，代表了创新型提问的程度。
                    </div>
                </div>
                <div class="top-h3 f-l">6.2 雷达图</div>
                <div class="charts-container">
                    <flds-radar-chart :id="'fldsRadarEchart'" :data-list="this.fldsChart"/>
                    <div class="clearfix">
                        <p class="p1">说明：</p>
                        <p class="p2">弗兰德斯雷达图旨在分析互动的质量。面积越大，互动质量越好。某个维度取值越高，表示该方面做的越好。图中的橙色虚线表示的是常模。</p>
                    </div>
                </div>
                <div class="top-h3 f-l">6.3 弗兰德斯互动分析</div>
                <div class="charts-container">
                    <div class="model-container">
                        <table class="tablecss">
                            <thead>
                            <tr >
                                <th align="center" style="width: 20%;">指标类型</th>
                                <th align="center" style="width: 10%;">当前值</th>
                                <th align="center" style="width: 10%;">常模</th>
                                <th style="width: 60%;">含义</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td align="left" style="font-weight: bold;padding-left: 10px;height: 30px;" colspan="4">1、课堂结构</td>
                            </tr>
                            <tr>
                                <td align="center">TT 教师讲话百分比</td>
                                <td align="center">{{(Number(this.fldsInteractionData.t_language_rate)/100).toFixed(2)}}</td>
                                <td align="center">0.68</td>
                                <td>
                                    教师在课堂上讲话所占时间的比例。较高的百分比表示教师主导课堂的程度较高，但也可能抑制了学生的主动参与和创造性思维。
                                </td>
                            </tr>
                            <tr>
                                <td align="center">PT 学生讲话百分比</td>
                                <td align="center">{{(Number(this.fldsInteractionData.s_language_rate)/100).toFixed(2)}}</td>
                                <td align="center">0.2</td>
                                <td>
                                    学生在课堂上讲话所占时间的比例。较高的百分比表明课堂较为开放，学生参与度高，教师主导地位下降，促进了学生主动学习。
                                </td>
                            </tr>
                            <tr>
                                <td align="center">SC 沉默或非活跃百分比</td>
                                <td align="center">{{(Number(this.fldsInteractionData.chaos_rate)/100).toFixed(2)}}</td>
                                <td align="center">0.12</td>
                                <td>
                                    课堂中安静或混乱的时间比例。较低的百分比表明课堂教学活动高效，较高的百分比可能是探究式教学中正常的现象。
                                </td>
                            </tr>
                            <tr>
                                <td align="left" style="font-weight: bold;padding-left: 10px;height: 30px;" colspan="4">2、教师倾向</td>
                            </tr>
                            <tr>
                                <td align="center">I/D 教师间接影响与直接影响比率</td>
                                <td align="center">{{(Number(this.fldsInteractionData.t_ind_dir_rate)).toFixed(2)}}</td>
                                <td align="center">0.2</td>
                                <td>
                                    教师间接影响与直接影响的比例。高于1表明教师倾向于间接影响，低于1则表明教师偏向直接影响，反映了教师的教学风格和适应能力。
                                </td>
                            </tr>
                            <tr>
                                <td align="center">TRR 教师反应比率</td>
                                <td align="center">{{(Number(this.fldsInteractionData.t_pos_pas_rate)).toFixed(2)}}</td>
                                <td align="center">0.42</td>
                                <td>
                                    教师对学生表现、观念和感觉的积极反应所占比例。较高的比例表示教师善于通过鼓励和认可来促进学生参与。
                                </td>
                            </tr>
                            <tr>
                                <td align="left" style="font-weight: bold;padding-left: 10px;height: 30px;" colspan="4">3、互动质量</td>
                            </tr>
                            <tr>
                                <td align="center">TQR教师发问比率</td>
                                <td align="center">{{(Number(this.fldsInteractionData.t_quiz_rate)/100).toFixed(2)}}</td>
                                <td align="center">0.26</td>
                                <td>
                                    教师发问时间占其教学时间的比例。较高的比例表明教师通过提问促进学生思考，较低的比例可能表明教师在提问方面的使用较少。
                                </td>
                            </tr>
                            <tr>
                                <td align="center">PIR 学生自发发问比率</td>
                                <td align="center">{{(Number(this.fldsInteractionData.s_init_rate)/100).toFixed(2)}}</td>
                                <td align="center">0.34</td>
                                <td>
                                    学生主动发问的时间占其总发言时间的比例。较高的比例表明学生更积极地提出问题。
                                </td>
                            </tr>
                            <tr>
                                <td align="center">CCR内容十字区比率</td>
                                <td align="center">{{(Number(this.fldsInteractionData.focus_rate)/100).toFixed(2)}}</td>
                                <td align="center">0.55</td>
                                <td>
                                    教师语言与教学内容的相关性占全部教学时间的比例。较高的比例表示师生互动围绕教学内容展开。
                                </td>
                            </tr>
                            <tr>
                                <td align="center">SSR师生话题交流稳定比率</td>
                                <td align="center">{{(Number(this.fldsInteractionData.st_topic_stability)/100).toFixed(2)}}</td>
                                <td align="center">0.5</td>
                                <td>
                                    师生交流中停留在同一话语类别超过3秒的时间比例。较高的比例表明师生交流较为稳定。
                                </td>
                            </tr>
                            <tr>
                                <td align="center">PSSR学生表达稳定比率</td>
                                <td align="center">{{(Number(this.fldsInteractionData.s_expressive_ability)/100).toFixed(2)}}</td>
                                <td align="center">0.35</td>
                                <td>
                                    学生在同一话语类别中停留超过3秒的时间比例。较高的比例表明学生的发言较为稳定。
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <!-- 课堂类型分析数据-->
        <el-dialog :title="'教学模式分析'" v-model="isShowLessonTypeData"
                   top="0"
                   :width="dimDialogWidth" :show-close="true"
                   @opened="lessonChartReady = true">
            <div class="dim-title">
                1.S-T课堂趋势分析
            </div>
            <div class="dim-content2">
                <st-data-chart :id="'stDataEchart2'"
                               v-if="lessonChartReady"
                               :data-list="stList"/>
                <div class="clearfix">
                    <p class="p1">说明：</p>
                    <p class="p2">师生互动曲线描述的是老师和学生的互动情况。</p>
                    <p class="p2">沿横轴方向的线段代表老师行为，沿纵轴方向的线段代表学生行为。</p>
                    <p class="p2">当曲线偏向横轴时，表示老师活动占多数，偏向纵轴时，学生活动占多数。</p>
                    <p class="p2">当某段曲线整体平行于45 度线时，表示在此段时间内老师学生互动充分。</p>
                </div>
            </div>
            <div class="dim-title">2.课堂教学模式分析</div>
            <div class="dim-content2">
                <rt-ch-data-chart :id="'rtChDataEchart2'"
                                  v-if="lessonChartReady"
                                  :rt-num="this.rt"
                                  :ch-num="this.ch"/>
                <div class="clearfix">
                    <p class="p1">说明：</p>
                    <table class="tablecss">
                        <tbody>
                        <tr>
                            <td align="center" style="font-weight: bold; width: 40%;border-bottom: 1px solid #ccc;">Rt（教师行为占有率）</td>
                            <td style="padding: 10px;border-left: 1px solid #ccc;border-bottom: 1px solid #ccc;">{{(rt/100).toFixed(3)}}</td>
                        </tr>
                        <tr>
                            <td align="center" style="font-weight: bold; width: 40%;border-bottom: 1px solid #ccc;">Ch（转换率）</td>
                            <td style="padding: 10px;border-left: 1px solid #ccc;border-bottom: 1px solid #ccc;">{{(ch/100).toFixed(3)}}</td>
                        </tr>
                        <tr>
                            <td align="center" style="font-weight: bold; width: 40%;">课堂类型</td>
                            <td style="padding: 10px;border-left: 1px solid #ccc;">{{lessonType}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <p class="p2">练习型：Rt↓，Ch↓ （Rt ≤ 0.3）</p>
                    <p class="p2">讲授型：Rt↑，Ch↓ （Rt ≥ 0.7）</p>
                    <p class="p2">对话型：Rt居中，Ch↑ （Ch ≥ 0.4）</p>
                    <p class="p2">混合型：0.3 ≤ Rt ≤ 0.7，Ch &lt; 0.4</p>
                    <p class="p2">其物理意义为：Rt↑→教师活动多；Ch↑→师生互动多。</p>
                </div>
            </div>
            <div class="dim-title">
                3.弗兰德斯模型
            </div>
            <div class="dim-title2">
                3.1弗兰德斯分析-矩阵图
            </div>
            <div class="charts-container">
                <div class="model-container">
                    <table class="tablecss flds-matrix">
                        <tbody>
                        <tr style="height: 50px;">
                            <td align="center" :rowspan="2" style="width: 6%;">分类</td>
                            <td align="center" :colspan="7">教师语言</td>
                            <td align="center" :colspan="3">学生语言</td>
                            <td align="center" :colspan="2">课堂状态</td>
                            <td align="center" :colspan="2">多媒体技术</td>
                        </tr>
                        <tr style="height: 180px;">
                            <td align="center" style="width: 6.6%;">接纳情感</td>
                            <td align="center" style="width: 6.6%;">鼓励或表扬</td>
                            <td align="center" style="width: 6.6%;">接纳或利用学生的观点</td>
                            <td align="center" style="width: 6.6%;">提问</td>
                            <td align="center" style="width: 6.6%;">讲授</td>
                            <td align="center" style="width: 6.6%;">给予指导或指令</td>
                            <td align="center" style="width: 6.6%;">批评或维护权威性</td>
                            <td align="center" style="width: 6.6%;">学生应答</td>
                            <td align="center" style="width: 6.6%;">学生主动说话</td>
                            <td align="center" style="width: 6.6%;">小组讨论</td>
                            <td align="center" style="width: 6.6%;">无助于教学的混乱</td>
                            <td align="center" style="width: 6.6%;">思考练习笔记</td>
                            <td align="center" style="width: 6.6%;">教师应用技术</td>
                            <td align="center" style="width: 6.6%;">学生应用技术</td>
                        </tr>
                        <tr style="height: 50px;">
                            <td align="center" style="width: 6%;">序号</td>
                            <td align="center" style="width: 6.6%;">1</td>
                            <td align="center" style="width: 6.6%;">2</td>
                            <td align="center" style="width: 6.6%;">3</td>
                            <td align="center" style="width: 6.6%;">4</td>
                            <td align="center" style="width: 6.6%;">5</td>
                            <td align="center" style="width: 6.6%;">6</td>
                            <td align="center" style="width: 6.6%;">7</td>
                            <td align="center" style="width: 6.6%;">8</td>
                            <td align="center" style="width: 6.6%;">9</td>
                            <td align="center" style="width: 6.6%;">10</td>
                            <td align="center" style="width: 6.6%;">11</td>
                            <td align="center" style="width: 6.6%;">12</td>
                            <td align="center" style="width: 6.6%;">13</td>
                            <td align="center" style="width: 6.6%;">14</td>
                        </tr>
                        <tr style="height: 50px;" v-for="(num,index) in mumList" :key="index">
                            <td align="center" style="width: 6%;">{{num}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+1">{{gainTableItem('tableId'+num+1)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+2">{{gainTableItem('tableId'+num+2)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+3">{{gainTableItem('tableId'+num+3)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+4">{{gainTableItem('tableId'+num+4)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+5">{{gainTableItem('tableId'+num+5)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+6">{{gainTableItem('tableId'+num+6)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+7">{{gainTableItem('tableId'+num+7)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+8">{{gainTableItem('tableId'+num+8)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+9">{{gainTableItem('tableId'+num+9)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+10">{{gainTableItem('tableId'+num+10)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+11">{{gainTableItem('tableId'+num+11)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+12">{{gainTableItem('tableId'+num+12)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+13">{{gainTableItem('tableId'+num+13)}}</td>
                            <td align="center" style="width: 6.6%;" :id="'tableId'+num+14">{{gainTableItem('tableId'+num+14)}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="flds-title1">积极整合格</div>
                <div class="flds-content">
                    矩阵中 1~3 行与 1~3 列相交的「黄色」区域是积极整合格，如在此区域记录是体现教师在授课过程中有采纳、表扬、鼓励学生的发言、行为、动作或者认可学生的观点，若此区域记录较为密集，反映出师生之间情感气氛融洽。
                </div>
                <div class="flds-title4">缺陷格</div>
                <div class="flds-content">
                    矩阵中 7~8 行与 6~7 列相交的「红色」区域是缺陷格，在此区域中记录，说明课堂内出现了教师为维护权威批评学生或指令学生做某些事情等非积极的情况发生。如果在这个区域中记录的次数很少，也反应教师与学生语言交流的融洽，如果在这个区域里记录的次数密集，则反映是教师和学生之间情感交流上的隔阂，是课堂上应注意避免的缺陷。
                </div>
                <div class="flds-title5">稳态格</div>
                <div class="flds-content">
                    矩阵中对角线上（左上到右下）的各个单元格叫做稳态格，编码落在这些格里，表示某种行为出现的时间超过 3 秒钟，表明持续地做某事。
                </div>
                <div class="flds-title3">提问引导格</div>
                <div class="flds-content">
                    矩阵中「绿色」区域为“提问引导”课堂类型。出现在此区域中是说明教师在教学过程中采用了提问、引导等手段来驱动学生回答，代表了训练型提问的程度。
                </div>
                <div class="flds-title2">主动延伸格</div>
                <div class="flds-content">
                    矩阵中「蓝色」区域为“主动延伸”课堂类型。出现在此区域中显示了教师在课堂内通过接受或采纳学生意见诱导学生主动发言的情况，代表了创新型提问的程度。
                </div>
            </div>
            <div class="dim-title2">
                3.2弗兰德斯互动分析-雷达图
            </div>
            <div class="charts-container">
                <small-flds-radar-chart :id="'smallFldsRadarEchart'" v-if="lessonChartReady" :data-list="this.fldsChart"/>
                <div class="clearfix">
                    <p class="p1">说明：</p>
                    <p class="p2">弗兰德斯雷达图旨在分析互动的质量。面积越大，互动质量越好。某个维度取值越高，表示该方面做的越好。图中的橙色虚线表示的是常模。</p>
                </div>
            </div>
            <div class="dim-title2">
                3.3弗兰德斯互动分析-表格
            </div>
            <div class="charts-container">
                <div class="model-container">
                    <table class="tablecss">
                        <thead>
                        <tr >
                            <th align="center" style="width: 20%;">指标类型</th>
                            <th align="center" style="width: 10%;">当前值</th>
                            <th align="center" style="width: 10%;">常模</th>
                            <th style="width: 60%;">含义</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td align="left" style="font-weight: bold;padding-left: 10px;height: 30px;" colspan="4">1、课堂结构分析（语言比例）</td>
                        </tr>
                        <tr>
                            <td align="center">TT 教师讲话百分比</td>
                            <td align="center">{{(Number(this.fldsInteractionData.t_language_rate)/100).toFixed(2)}}</td>
                            <td align="center">0.68</td>
                            <td>
                                教师在课堂上讲话所占时间的比例。较高的百分比表示教师主导课堂的程度较高，但也可能抑制了学生的主动参与和创造性思维。
                            </td>
                        </tr>
                        <tr>
                            <td align="center">PT 学生讲话百分比</td>
                            <td align="center">{{(Number(this.fldsInteractionData.s_language_rate)/100).toFixed(2)}}</td>
                            <td align="center">0.2</td>
                            <td>
                                学生在课堂上讲话所占时间的比例。较高的百分比表明课堂较为开放，学生参与度高，教师主导地位下降，促进了学生主动学习。
                            </td>
                        </tr>
                        <tr>
                            <td align="center">SC 沉默或非活跃百分比</td>
                            <td align="center">{{(Number(this.fldsInteractionData.chaos_rate)/100).toFixed(2)}}</td>
                            <td align="center">0.12</td>
                            <td>
                                课堂中安静或混乱的时间比例。较低的百分比表明课堂教学活动高效，较高的百分比可能是探究式教学中正常的现象。
                            </td>
                        </tr>
                        <tr>
                            <td align="left" style="font-weight: bold;padding-left: 10px;height: 30px;" colspan="4">2、教师倾向/风格分析</td>
                        </tr>
                        <tr>
                            <td align="center">I/D 教师间接影响与直接影响比率</td>
                            <td align="center">{{(Number(this.fldsInteractionData.t_ind_dir_rate)).toFixed(2)}}</td>
                            <td align="center">0.2</td>
                            <td>
                                教师间接影响与直接影响的比例。高于1表明教师倾向于间接影响，低于1则表明教师偏向直接影响，反映了教师的教学风格和适应能力。
                            </td>
                        </tr>
                        <tr>
                            <td align="center">TRR 教师反应比率</td>
                            <td align="center">{{(Number(this.fldsInteractionData.t_pos_pas_rate)).toFixed(2)}}</td>
                            <td align="center">0.42</td>
                            <td>
                                教师对学生表现、观念和感觉的积极反应所占比例。较高的比例表示教师善于通过鼓励和认可来促进学生参与。
                            </td>
                        </tr>
                        <tr>
                            <td align="left" style="font-weight: bold;padding-left: 10px;height: 30px;" colspan="4">3、其他指标分析</td>
                        </tr>
                        <tr>
                            <td align="center">TQR教师发问比率</td>
                            <td align="center">{{(Number(this.fldsInteractionData.t_quiz_rate)/100).toFixed(2)}}</td>
                            <td align="center">0.26</td>
                            <td>
                                教师发问时间占其教学时间的比例。较高的比例表明教师通过提问促进学生思考，较低的比例可能表明教师在提问方面的使用较少。
                            </td>
                        </tr>
                        <tr>
                            <td align="center">PIR 学生自发发问比率</td>
                            <td align="center">{{(Number(this.fldsInteractionData.s_init_rate)/100).toFixed(2)}}</td>
                            <td align="center">0.34</td>
                            <td>
                                学生主动发问的时间占其总发言时间的比例。较高的比例表明学生更积极地提出问题。
                            </td>
                        </tr>
                        <tr>
                            <td align="center">CCR内容十字区比率</td>
                            <td align="center">{{(Number(this.fldsInteractionData.focus_rate)/100).toFixed(2)}}</td>
                            <td align="center">0.55</td>
                            <td>
                                教师语言与教学内容的相关性占全部教学时间的比例。较高的比例表示师生互动围绕教学内容展开。
                            </td>
                        </tr>
                        <tr>
                            <td align="center">SSR师生话题交流稳定比率</td>
                            <td align="center">{{(Number(this.fldsInteractionData.st_topic_stability)/100).toFixed(2)}}</td>
                            <td align="center">0.5</td>
                            <td>
                                师生交流中停留在同一话语类别超过3秒的时间比例。较高的比例表明师生交流较为稳定。
                            </td>
                        </tr>
                        <tr>
                            <td align="center">PSSR学生表达稳定比率</td>
                            <td align="center">{{(Number(this.fldsInteractionData.s_expressive_ability)/100).toFixed(2)}}</td>
                            <td align="center">0.35</td>
                            <td>
                                学生在同一话语类别中停留超过3秒的时间比例。较高的比例表明学生的发言较为稳定。
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-dialog>
        <!-- 课堂评估量表数据分析-时序图-->
        <el-dialog :title="'('+this.dimData.targetname+')详细数据展示'"
                   v-model="isShowDimData" :width="dimDialogWidth"
                   :before-close="this.closeDimDataView"
                   :show-close="true"
                   @opened="dimChartReady = true">
            <div class="dim-title">
                1.教学定义
            </div>
            <div class="dim-content">
                {{this.dimData.result_read}}
            </div>
            <div class="dim-title">
                2.数据解析
            </div>
            <div class="dim-content">
                {{this.dimData.analysis}}
            </div>
            <div class="dim-title">
                3.详细数据展示
            </div>
            <div class="dim-content">
                <div class="model-container" v-if="Object.keys(gatherData).length>0">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" v-for="(value, key) in gatherData" :key="key">{{key}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td align="center" v-for="(value, key) in gatherData" :key="key">{{value}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="p2" style="text-align: center;width: 100%" v-if="Object.keys(gatherData).length===0">无此项数据</div>
            </div>
            <div class="dim-title">
                4.视频与时序图
            </div>
            <div class="dim-content3">
                <div class="dim-video">
                    <video id="skipVideoInfo"
                           :poster="taskInfo.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast'"
                           controls="controls" style="width: 100%;height: 100%;"
                           controlsList="nodownload"
                           :src="taskInfo.videoUrl">
                    </video>
                </div>
                <div class="dim-chart">
                    <second-data-sequence-echart :id="'secondDataSequenceEchart'"
                                                 v-if="dimChartReady"
                                                 :name="this.dimData.targetname"
                                                 :title="this.dimData.targetname+'时序图'"
                                                 :echart-data="this.echartData"
                                                 :sequence-echart-data="this.sequenceEchartData"
                                                 @skip-video="skipCourseVideo"/>
                </div>
            </div>
        </el-dialog>
        <!-- 课堂评估量表数据分析--折线-->
        <el-dialog :title="'('+this.lineDimData.targetname+')详细数据展示'" v-model="isShowLineData" :width="dimDialogWidth" :show-close="true" @opened="lineChartReady = true">
            <div class="dim-title">
                1.教学定义
            </div>
            <div class="dim-content">
                {{this.lineDimData.result_read}}
            </div>
            <div class="dim-title">
                2.数据解析
            </div>
            <div class="dim-content">
                {{this.lineDimData.analysis}}
            </div>
            <div class="dim-title">
                3.详细数据展示
            </div>
            <div class="dim-content">
                <div class="model-container" v-if="Object.keys(lineGatherData).length>0">
                    <table class="tablecss">
                        <thead>
                        <tr>
                            <th align="center" v-for="(value, key) in lineGatherData" :key="key">{{key}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td align="center" v-for="(value, key) in lineGatherData" :key="key">{{value}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="p2" style="text-align: center;width: 100%" v-if="Object.keys(lineGatherData).length===0">无此项数据</div>
            </div>
            <div class="dim-title">
                4.视频与折线图
            </div>
            <div class="dim-content3">
                <div class="dim-video">
                    <video id="videoElement"
                           :poster="taskInfo.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast'"
                           controls="controls" style="width: 100%;height: 100%;"
                           controlsList="nodownload"
                           :src="taskInfo.videoUrl">
                    </video>
                </div>
                <div class="dim-chart">
                    <second-data-line-echart :id="'secondDataLineEchart'"
                                             v-if="lineChartReady"
                                             :title="lineDimData.targetname+'折线图'"
                                             :data-list="lineSequenceEchartData"/>
                </div>
            </div>
        </el-dialog>
        <!-- 查看视频-->
        <el-dialog v-model="isCourseVideoVisible" :width="videoDialogWidth" :show-close="true"
                   append-to-body
                   :before-close="this.closeVideo">
            <video id="videoElement"
                   :poster="this.taskInfo.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast'"
                   controls="controls" style="width: 100%;height: 100%;"
                   controlsList="nodownload"
                   :src="this.taskInfo.videoUrl">
            </video>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import {infoCourseTask, infoCourseReport,queryDataAnalysis,
    queryAppendixAData,teachingEventData,classActivityData,
    teachingBehaviorData,interactiveEvaData,stData,rtChData,
    fldsInteractionData} from "@/api/admin/report";
import {timestampToTime} from "@/utils/date";
import {downloadFile } from "@/api/adminservice/public"
import radarChart from "@/components/reportCharts/radarChart";
import doubleBarChart from "@/components/reportCharts/doubleBarChart";
import teachingEventDataEchart from "@/components/reportCharts/teachingEventDataEchart";
import classActivityDataEchart from "@/components/reportCharts/classActivityDataEchart";
import teachingBehaviorDataEchart from "@/components/reportCharts/teachingBehaviorDataEchart";
import interactiveEvaDataEchart from "@/components/reportCharts/interactiveEvaDataEchart";
import stDataChart from "@/components/reportCharts/stDataChart";
import rtChDataChart from "@/components/reportCharts/rtChDataChart";
import fldsRadarChart from "@/components/reportCharts/fldsRadarChart";
import smallFldsRadarChart from "@/components/reportCharts/smallFldsRadarChart";
import secondDataSequenceEchart from "@/components/reportCharts/secondDataSequenceEchart";
import secondDataLineEchart from "@/components/reportCharts/secondDataLineEchart";
import {Pointer} from "@element-plus/icons-vue";
export default {
    name: "courseReportInfo",
    components: {Pointer, radarChart,doubleBarChart,
        teachingEventDataEchart,classActivityDataEchart,teachingBehaviorDataEchart,
        interactiveEvaDataEchart,stDataChart,rtChDataChart,fldsRadarChart,smallFldsRadarChart,
        secondDataSequenceEchart,secondDataLineEchart},
    data() {
        return {
            timestampToTime,
            isShowDimData:false,
            isShowLineData:false,
            isShowLessonTypeData:false,
            isCourseVideoVisible:false,
            serviceUrl,
            taskId:'',
            mumList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14],
            taskInfo:{},
            reportInfo:{},
            oneData:[],
            leveData:[],
            infoData: {},
            keyDifficult:{},//重点难点
            dataOverview:{},//综合指数和得分统计解读
            lightSpot:{},// 亮点
            insufficient:{},//能力增强点
            highData:{},
            lowData:{},
            //课标与教材解读
            chartData1:[],
            //教学设计实施
            chartData2:[],
            //教学反思评价
            chartData3:[],
            //技术融合教学
            chartData4:[],
            //教学效果评估
            chartData5:[],
            //维度数据解析
            queryDimDataForm:{
                taskId:'',
                middleId:'',
            },
            dimData:{},
            echartData:[],//Echart图表
            gatherData: {},//详细数据
            sequenceEchartData:[], //序列图表数据
            lineDimData:{},
            lineEchartData:[],//Echart图表
            lineGatherData: {},//详细数据
            lineSequenceEchartData:[], //序列图表数据
            //评估指标教学定义
            evaData: {},
            evaList:[],
            // 导航跳转
            parentId:'',
            itemId:'',
            // 窗口宽度（用于弹窗自适应）
            windowWidth: window.innerWidth,
            // 弹窗内图表在打开动画结束（opened）后再挂载，避免首次打开画布被压缩
            lessonChartReady: false,
            dimChartReady: false,
            lineChartReady: false,
            //附录B-课堂教学事件分析数据
            teachingEventData:[],
            //附录B-课堂活动分析
            classActivityData:[],
            //附录B-教学行为分析
            teachingBehaviorObj: {},
            teachingBehaviorData:[],
            //附录B-师生对话深度评估
            interactiveEvaData:[],
            // 附录B-ST折线图数据
            stData:{},
            stList:[],
            // 附录B-RT-CH图数据
            lessonType:'',
            rtchData:{},
            rt:0,
            ch:0,
            // 附录B-弗兰德斯教学模型互动矩阵图数据
            fldsInteractionData:{},
            coordinateList:[],
            fldsMap:new Map(),
            fldsChart:[],
        };
    },
    created() {
        if (this.$route.query.taskId) {
            this.taskId = this.$route.query.taskId
            this.queryDimDataForm.taskId = this.$route.query.taskId
            this.queryCourseTaskInfo();
            this.queryReportInfo();
            this.handleEvaData();
            this.queryTeachingEventData();
            this.queryClassActivityData();
            this.queryTeachingBehaviorData();
            this.queryInteractiveEvaData();
            this.queryStData();
            this.queryRtChData();
            this.queryFldsInteractionData();
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowResize);
    },
    unmounted() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
    computed: {
        // 数据展示类弹窗宽度：手机端占满，其余 75%
        dimDialogWidth() {
            return this.windowWidth < 768 ? '95%' : '75%';
        },
        // 视频弹窗宽度：手机端占满，其余 60%
        videoDialogWidth() {
            return this.windowWidth < 768 ? '95%' : '60%';
        }
    },
    methods: {
        handleWindowResize() {
            this.windowWidth = window.innerWidth;
        },
        queryCourseTaskInfo(){
            infoCourseTask({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.taskInfo = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }

            })
        },
        queryReportInfo(){
            infoCourseReport({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.reportInfo = JSON.parse(res.data.data);
                    this.oneData = this.reportInfo.one_data;
                    this.leveData = this.reportInfo.leve_data.target;
                    this.infoData = this.reportInfo.reportinfo;
                    this.keyDifficult = JSON.parse(this.infoData.keydifficult);
                    this.dataOverview = JSON.parse(this.infoData.dataoverview);
                    this.lightSpot = JSON.parse(this.infoData.lightspot);
                    this.insufficient = JSON.parse(this.infoData.insufficient);
                    this.highData = this.dataOverview.最高;
                    this.lowData = this.dataOverview.最低;
                    this.separateChartData();
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleDownload() {
            downloadFile(this.taskInfo.reportUrl, this.taskInfo.taskName+'.pdf')
        },
        separateChartData(){
            this.leveData.forEach(item =>{
                if ("课标与教材解读"===item.name){
                    this.chartData1 = item.second_target;
                }
                if ("教学设计实施"===item.name){
                    this.chartData2 = item.second_target;
                }
                if ("教学反思评价"===item.name){
                    this.chartData3 = item.second_target;
                }
                if ("技术融合教学"===item.name){
                    this.chartData4 = item.second_target;
                }
                if ("教学效果评估"===item.name){
                    this.chartData5 = item.second_target;
                }
            })
        },
        handleDataAnalysis(middleId){
            this.dimData = {};
            this.echartData = [];
            this.gatherData = {};
            this.sequenceEchartData = [];
            this.queryDimDataForm.middleId = middleId;
            queryDataAnalysis(this.queryDimDataForm).then(res => {
                if (res.data.code === 1) {
                    this.dimData = JSON.parse(res.data.data);
                    if (this.dimData.targetname==='学生课堂参与度'||this.dimData.targetname==='学生课堂专注度'){
                        this.handleDataAnalysisLine(middleId)
                    }else {
                        this.handleDataAnalysisSeq(middleId)
                    }
                }else {
                    this.$message.error(res.data.msg);
                }
            })

        },
        // 时序图
        handleDataAnalysisSeq(){
            this.echartData = JSON.parse(this.dimData.echart_data);
            this.gatherData = JSON.parse(this.dimData.gather_data);
            this.sequenceEchartData = JSON.parse(this.dimData.sequence_echart_data);
            this.isShowDimData = true;

        },
        // 折线图
        handleDataAnalysisLine(){
            this.lineDimData = this.dimData;
            this.lineEchartData = JSON.parse(this.lineDimData.echart_data);
            this.lineGatherData = JSON.parse(this.lineDimData.gather_data);
            this.lineSequenceEchartData = JSON.parse(this.lineDimData.sequence_echart_data);
            this.isShowLineData = true;
        },
        handleEvaData(){
            queryAppendixAData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.evaData = JSON.parse(res.data.data);
                    this.evaList= this.evaData.target;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        jumpToItem(pid,id){
            this.parentId = pid;
            this.itemId = id;
            const targetElement = document.querySelector('#'+id); // 获取目标元素
            if (targetElement) {
                targetElement.scrollIntoView(
                  { block: 'center', behavior: 'smooth' },
                ); // 平滑滚动到目标元素
            }
        },
        queryTeachingEventData(){
            teachingEventData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.teachingEventData = JSON.parse(res.data.data);
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        queryClassActivityData(){
            classActivityData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.classActivityData = JSON.parse(res.data.data);
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        queryTeachingBehaviorData(){
            teachingBehaviorData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.teachingBehaviorObj = JSON.parse(res.data.data);
                    this.teachingBehaviorData = this.teachingBehaviorObj.event;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        queryInteractiveEvaData(){
            interactiveEvaData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.interactiveEvaData = JSON.parse(res.data.data);
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        queryStData(){
            stData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.stData = JSON.parse(res.data.data);
                    const xl = JSON.parse(this.stData.x);
                    const yl = JSON.parse(this.stData.y);
                    const list = [];
                    xl.forEach((x,index )=> {
                        const item = [x,yl[index]]
                        list.push(item)
                    })
                    this.stList = list;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        queryRtChData(){
            rtChData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.rtchData = JSON.parse(res.data.data);
                    this.rt = Number(this.rtchData.rt);
                    this.ch = Number(this.rtchData.ch);
                    // 判断类型
                    if (this.rt<=30){
                        this.lessonType = '练习型';
                    }else if (this.rt>=70){
                        this.lessonType = '讲授型';
                    }else if (this.ch>=40){
                        this.lessonType = '对话型';
                    }else {
                        this.lessonType = '混合型';
                    }
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        queryFldsInteractionData(){
            fldsInteractionData({taskId:this.taskId}).then(res => {
                if (res.data.code === 1) {
                    this.fldsInteractionData = JSON.parse(res.data.data);
                    this.coordinateList = JSON.parse(this.fldsInteractionData.coordinate);
                    if (this.coordinateList&&this.coordinateList.length>0){
                        this.coordinateList.forEach((item)=>{
                            this.fldsMap.set("tableId"+item[0]+item[1],item[2])
                        })
                    }
                    // 雷达图数据
                    const list = [];
                    list.push((Number(this.fldsInteractionData.t_language_rate)/100).toFixed(2))
                    list.push((Number(this.fldsInteractionData.s_language_rate)/100).toFixed(2))
                    list.push((Number(this.fldsInteractionData.chaos_rate)/100).toFixed(2))
                    list.push((Number(this.fldsInteractionData.t_quiz_rate)/100).toFixed(2))
                    list.push((Number(this.fldsInteractionData.s_init_rate)/100).toFixed(2))
                    list.push((Number(this.fldsInteractionData.focus_rate)/100).toFixed(2))
                    list.push((Number(this.fldsInteractionData.st_topic_stability)/100).toFixed(2))
                    list.push((Number(this.fldsInteractionData.s_expressive_ability)/100).toFixed(2))
                    this.fldsChart = list;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        gainTableItem(key){
            return this.fldsMap.get(key)?this.fldsMap.get(key):0;
        },
        handleLessonTypeDataView(){
            this.isShowLessonTypeData = true;
        },
        videoCourseVideo(timeSecond){
            this.isCourseVideoVisible = true;
            setTimeout(function() {
                document.getElementById('videoElement').currentTime =timeSecond;
                document.getElementById('videoElement').play();
            }, 1e3);

        },
        closeVideo(){
            document.getElementById('videoElement').pause();
            this.isCourseVideoVisible = false;
        },
        skipCourseVideo(timeSecond){
            setTimeout(function() {
                document.getElementById('skipVideoInfo').currentTime =timeSecond;
                document.getElementById('skipVideoInfo').play();
            }, 1e3);
        },
        closeDimDataView(){
            document.getElementById('skipVideoInfo').currentTime =0;
            document.getElementById('skipVideoInfo').pause();
            this.isShowDimData = false;
        }
    }
};
</script>
<style scoped>
.re-container{
    width: 100%;
    height: auto;
}
.re-stat-scrollbar{
    height: calc(100vh - 10px);
    width: calc(100% - 10px);
    padding: 5px 5px 5px 5px;
    background-color: #fff;
    overflow-x: hidden!important;

}
.top-container{
    width: 100%;
    height: 50px;
    display: flex;
    border-bottom: 1px solid #e6e6e6;
}
.top-item1{
    flex: 0 0 auto;
    min-width: 120px;
    height: 50px;
}
.top-item2{
    flex: 1;
    min-width: 0;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    font-family: sans-serif;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.download-btn-l{
    width: 120px;
    height: 36px;
    background-color: #ff7f2e;
    color: #fff;
    text-align: center;
    line-height: 36px;
    margin: 7px 0 0 5px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    font-family: sans-serif;
    cursor: pointer;
}
.download-btn-r{
    width: 120px;
    height: 36px;
    background-color: #ff7f2e;
    color: #fff;
    text-align: center;
    line-height: 36px;
    margin: 7px 0 0 25px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    font-family: sans-serif;
    cursor: pointer;
}
.report-container{
    width: 100%;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
/* 信息组：宽度取最长一行，整体居中，各行名称左对齐 */
.report-info-center{
    width: fit-content;
    max-width: 100%;
    margin: 0 auto;
    text-align: left;
}
.report-info-item{
    min-height: 44px;
    line-height: 44px;
    text-align: left;
    color: #333;
    word-break: break-all;
}
.r-font{
    font-weight: bold!important;
    font-family: sans-serif;
}
.item-gd{
    height: 30px;
}
.top-h2{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 22px;
    font-weight: bold;
    font-family: sans-serif;
}
.top-h3{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
}
.top-h4{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    font-family: sans-serif;
    text-indent: 10px;
}
.f-l{
    text-align: left;
}
.f-r{
    text-align: right;
}
.f-c{
    text-align: center;
}
.p-indent {
    text-indent: 2em;
    line-height: 30px;
    font-family: sans-serif;
    font-size: 15px;
    color: #333;
}
.model-container{
    width: 98% !important;
    line-height: 35px;
    color: #000;
    margin: 0 auto;
    padding: 0;
    font-family: sans-serif;
    background: #fff;
    box-sizing: border-box;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.model-container table {
    width: 100%;
    color: #333;
    border-spacing: 0;
}
.tablecss {
    width: 95%;
    border: 1px solid #ccc;
    font-size: 14px;
    line-height: 25px;
    border-spacing: 0;
}
/* model-container 已支持横向滚动，窄屏下保持表格可读的最小宽度 */
.model-container .tablecss {
    min-width: 560px;
}
/* 弗兰德斯 14 列互动矩阵，窄屏横向滚动 */
.flds-matrix {
    min-width: 768px;
}
.model-container table thead th {
    text-align: center;
    //border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    color: #333;
    font-weight: 600;
}
.model-container table th {
    background-color: #cbaa63;
}
.model-container table td {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    font-weight: 400;
    font-size: 14px;
}
.border-l-none{
    border-left: none !important;
}
.charts-container{
    width: 98%;
    height: auto;
    border: 1px solid #ebeef5;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
}
.rating {
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    color: #333;
    padding: 10px;
    border-radius: 5px;
}
.xiahuaxian {
    text-decoration: underline;
    font-weight: 700 !important;
    color: #666;
}
.legend{
    display: flex;
    align-items: center;
    justify-content: center;
}
.legend-color {
    width: 10px;
    height: 10px;
    margin-right: 3px;
    margin-left: 5px;
}
.legend-text {
    font-size: 14px;
    color: #666;
    margin-right: 5px;
}
.progress-container{
    margin: 5px;
}
.blue-link{
    cursor: pointer;
    color: green;
    text-decoration: underline;
}
/deep/ .el-progress-bar__innerText{
    color: #333;
    margin-top: -2px;
}
.menu-parent{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 700;
    font-family: sans-serif;
    cursor: pointer!important;
    color: #333;
    padding-left: 5px;
}
.subsections{
    list-style-type: none;
    padding: 0;
    margin: 0;
}
.subsections li{
    padding: 3px;
    cursor: pointer;
    color: #666;
    font-size: 14px;
    text-overflow: ellipsis;
}
.active{
    background-color: #ff7f2e;
    color: #fff!important;
}
.dim-title{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: bold;
    font-family: sans-serif;
    text-indent: 10px;
    color: #606266;
}
.dim-title2{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    text-indent: 20px;
    color: #606266;
}
.dim-content{
    width: 98%;
    height: auto;
    font-size: 14px;
    font-family: sans-serif;
    color: #666666;
    border: 1px solid #ebeef5;
    padding: 10px;
    box-sizing: border-box;
    margin: auto;
    display: flex;
}
.dim-content2{
    width: 98%;
    height: auto;
    font-size: 14px;
    font-family: sans-serif;
    color: #666666;
    border: 1px solid #ebeef5;
    padding: 10px;
    box-sizing: border-box;
    margin: auto;
}
.dim-content3{
    width: 98%;
    border: 1px solid #ebeef5;
    display: flex;
    flex: 1 10%;
    margin: auto;
}
.dim-video{
    flex: 1 1 0;
    min-width: 0;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
}
.dim-chart{
    flex: 1 1 0;
    min-width: 0;
    height: 100%;
    min-height: 380px;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    position: relative;
}
.clearfix{
    zoom: 1;
}
.p1{
    font-family: sans-serif;
    font-style: normal;
    color: #000;
    font-size: 16px;
    //line-height: 25px;
    font-weight: bold;
}
.p2{
    font-family: sans-serif;
    font-style: normal;
    font-size: 14px;
    color: #666;
    //line-height: 20px;
}
#tableId11,
#tableId12,
#tableId13,
#tableId21,
#tableId22,
#tableId23,
#tableId31,
#tableId32,
#tableId33{
    background: #ffc000;
}

#tableId34,
#tableId35,
#tableId36,
#tableId37,
#tableId38,
#tableId39,
#tableId43,
#tableId53,
#tableId63,
#tableId73,
#tableId83,
#tableId93,
#tableId94,
#tableId95,
#tableId96,
#tableId97,
#tableId98,
#tableId99,
#tableId89,
#tableId79,
#tableId69,
#tableId59,
#tableId49{
    background: #1f75fe;
}
#tableId44,
#tableId45,
#tableId46,
#tableId47,
#tableId48,
#tableId58,
#tableId68,
#tableId78,
#tableId88,
#tableId84,
#tableId85{
    background: #1cac78;
}

#tableId76,
#tableId77,
#tableId86,
#tableId87{
    background: #ee204d;
}
.flds-title1{
    font-size: 16px;
    font-weight: bold;
    color: #ffc000;
    height: 30px;
    line-height: 40px;
    text-indent: 15px;
}
.flds-title2{
    font-size: 16px;
    font-weight: bold;
    color: #1f75fe;
    height: 30px;
    line-height: 40px;
    text-indent: 15px;
}
.flds-title3{
    font-size: 16px;
    font-weight: bold;
    color: #1cac78;
    height: 30px;
    line-height: 40px;
    text-indent: 15px;
}
.flds-title4{
    font-size: 16px;
    font-weight: bold;
    color: #ee204d;
    height: 30px;
    line-height: 40px;
    text-indent: 15px;
}
.flds-title5{
    font-size: 16px;
    font-weight: bold;
    color: #808080;
    height: 30px;
    line-height: 40px;
    text-indent: 15px;
}
.flds-content{
    font-size: 13px;
    font-weight: bold;
    color: #909399;
    height: auto;
    text-indent: 15px;
    padding: 10px 0 0 0;
}

/deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 20px;
    color: #333;
    font-weight: bold;
}

/* Pad 竖屏及以下：弹窗内视频与图表纵向堆叠 */
@media (max-width: 992px) {
    .dim-content3 {
        flex-direction: column;
    }
    .dim-video {
        padding: 10px;
    }
    .charts-container {
        padding: 15px;
    }
}

/* 手机端适配 */
@media (max-width: 768px) {
    .re-stat-scrollbar {
        width: 100%;
        padding: 0;
    }
    .top-item1 {
        min-width: 0;
    }
    .top-item2 {
        font-size: 15px;
    }
    .download-btn-l,
    .download-btn-r {
        width: 96px;
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        margin: 9px 0 0 5px;
    }
    .report-container {
        padding: 5px;
    }
    .top-h2 {
        height: auto;
        line-height: 40px;
        font-size: 18px;
    }
    .top-h3 {
        height: auto;
        line-height: 36px;
        font-size: 15px;
    }
    .top-h4 {
        font-size: 14px;
    }
    .p-indent {
        font-size: 14px;
        line-height: 26px;
    }
    .charts-container {
        padding: 10px;
    }
    .dim-title {
        height: auto;
        line-height: 40px;
        font-size: 15px;
    }
    .dim-chart {
        min-height: 300px;
    }
    .menu-parent {
        font-size: 14px;
    }
}
</style>